'use strict';

/* global $ */

import { breakpoints } from '../settings'

function Product(){

	// Create a clone of the menu, right next to original.
	$('.js-btns').addClass('orig-btns').clone().insertAfter('.js-btns')
    .addClass('cloned').css('position','fixed').css('top',0).css('margin-top','0px')
    .css('z-index','3').removeClass('orig-btns').addClass('stick-btns').hide();

	function inter() {
		// if ($(window).width() > breakpoints.xxs+60 && $(window).width() < breakpoints.m){
        if ($(window).width() < breakpoints.m){
		    $(window).on('scroll', stickIt);
		}else {
			$('.js-btns div:last').remove();

		}
	}

	$(window).on('resize', function(){ inter()});
	inter();
	function stickIt() {

		var orgElementPos = $('.orig-btns').offset();
		let orgElementTop = orgElementPos.top;               
        let pageY = window.pageYOffset || document.documentElement.scrollTop; 
        let stickhead = $('.stick-header').height();
        if ($('.stick-header').is(':hidden')){
            stickhead = 0;
        } 
		if ( pageY >= (orgElementTop-stickhead)) {
			$('.orig-btns').css('visibility','hidden');
			// scrolled past the original position; now only show the cloned, sticky element.

			// Cloned element should always have same left position and width as original element.     
			let orgElement = $('.original');
			let coordsOrgElement = orgElement.offset();

			// $('.orig-btns').css('visibility','hidden');
			$('.stick-btns').css('top',stickhead).addClass('active').show();

		} else {
			// not scrolled past the menu; only show the original menu.
			$('.stick-btns').hide().removeClass('active');
			$('.orig-btns').css('visibility','visible');
		}
	}

	let items = '.js-prop-item',
		contents = '.js-prop-content',
		links = '.js-prop-link';

    $(links).click(function (e){
        e.preventDefault();
        let item = $(this).toggleClass('active').closest($(items));
        item.find($(contents)).slideToggle(300);
    });

    $('.js-product-slider-main').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '.js-product-slider-arrow.m--prev',
        nextArrow: '.js-product-slider-arrow.m--next',
        arrows: true,
        appendDots: '.js-product-slider-main',
        dotsClass: 'product-page__slider-dots js-home-slider-dots',
        dots: true,
        infinite: false,
        fade: false,
        draggable: false,
        centerMode: false,
        accessibility: false,
        responsive: [
            {
                breakpoint: breakpoints.m,
                settings: {
        	        slidesToShow: 2.5,
                	fade: false,        
                	centerMode: true,
        			centerPadding: '40px',
                }
            },
            {
                breakpoint: breakpoints.xs,
                settings: {
        	        slidesToShow: 1,
                	fade: false,                	
                	centerMode: false,
                }
            },
        ]
    });
}

export {
    Product
};